import { useCallback } from 'react';
import { useApiKeysApi } from '../api';
import { CreateApikeyRequestData, UpdateApikeyRequestData } from '../types';

export const useApikeyService = () => {
  const api = useApiKeysApi();

  const createApikey = useCallback(async (data: CreateApikeyRequestData, companyId: string) => {
    const response = await api.createApikey(data, companyId);
    return response.data;
  }, []);

  const updateApikey = useCallback(
    async (data: UpdateApikeyRequestData, apikeyId: string, companyId: string) => {
      const response = await api.updateApikey(data, apikeyId, companyId);
      return response.data;
    },
    [],
  );

  const deleteApikeys = useCallback(async (ids: string[], companyId: string) => {
    await api.deleteApikeys(ids, companyId);
  }, []);

  const renewApikey = useCallback(async (apikeyId: string, companyId: string) => {
    const response = await api.renewApikey(apikeyId, companyId);
    return response.data;
  }, []);

  return {
    createApikey,
    updateApikey,
    deleteApikeys,
    renewApikey,
  };
};
